module.exports = __webpack_public_path__ + "img/Porto Apartment - 51 of 85.e1ad9fe1.jpeg";